export enum TransactionCategoryEnum {
  SALARY = 'SALARY',
  INVESTOR = 'INVESTOR',
  IN_APP_PURCHASE = 'IN_APP_PURCHASE',
  MARKETING = 'MARKETING',
  MARKETING_GOVOIR = 'MARKETING_GOVOIR',
  ADMINISTRATION = 'ADMINISTRATION',
  INFRASTRUCTURE = 'INFRASTRUCTURE',
  BANK_EXPENSE = 'BANK_EXPENSE',
  OTHER_INCOME = 'OTHER_INCOME',
  OTHER = 'OTHER',
}
